export const GOAL_OWNER_FILTER_URL_KEYS = {
    scope: "scope",
    segmentId: "segment",
    q: "q",
    adHocFilter: "rules",
    hasGoals: "has-goals",
    needsUpdate: "needs-update",
    cycleIds: "cycle-ids",
    allCycles: "all-cycles"
} as const;

export const GOAL_OWNER_FILTER_QUERY_KEYS: readonly string[] = Object.values(GOAL_OWNER_FILTER_URL_KEYS);
